import { IPaginated, ITalkBasePayload, IUser, PeerSelectionStatus } from "src/common/types";
import { IExtendedUser } from "./user";

export enum PeerSubmissionStatus {
  Submitted = "SUBMITTED",
  Read = "READ",
  NotSubmitted = "NOT_SUBMITTED"
}

export const peerSubmissionStatuses = {
  [PeerSubmissionStatus.Submitted]: "submitted",
  [PeerSubmissionStatus.Read]: "read",
  [PeerSubmissionStatus.NotSubmitted]: "notSubmitted"
};

export interface IMyPeersPayload extends IPaginated {
  entities: IMyPeer[];
}

export interface IMyPeer extends IUser {
  talks: ITalkBasePayload[];
}

export interface IPeerSelectionPayload {
  status: PeerSelectionStatus;
  peers: IExtendedUser[] | null;
}
